import { Chip, type ChipProps } from '@mui/material'
import type { FC } from 'react'

export type MolsonChipProps = ChipProps & {
  dataTestId?: string
}

export const MolsonChip: FC<MolsonChipProps> = ({ dataTestId, ...props }) => {
  return <Chip data-testid={dataTestId} {...props} />
}
